import { keyframes } from '@emotion/react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ListErrors from './ListErrors';
import React, { useState, useEffect } from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import {
  UPDATE_FIELD_AUTH,
  LOGIN,
  LOGIN_PAGE_UNLOADED, BOTTOM_NAVIGATION_VISIBILITY
} from '../constants/actionTypes';
import useTranslation from "../customHooks/translations";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { DEFAULT_THEME_COLOR, DEFAULT_GRADIENT, DEFAULT_GRADIENT_HOVER } from "../constants/theme";
import { sanitizeInput } from "../utils/sanitize";
import { useAuth0 } from "@auth0/auth0-react";
import AddToHomeScreenButton from './AddToHomeScreen/AddToHomeScreenButton';
import Divider from '@mui/material/Divider';

const titleShine = keyframes`
  0% { background-position: -200% center; }
  100% { background-position: 200% center; }
`;

export const Login = (props) => {
  const translation = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const redirectTo = new URLSearchParams(location.search).get('redirectTo') || '/freak';
  const { loginWithRedirect } = useAuth0();

  const [returnTo, setReturnTo] = useState('/freak');

  let changeEmail;
  let changePassword;
  let submitForm;

  const [_email, setEmail] = useState('');
  const [_password, setPassword] = useState('');

  useEffect(() => {
    props.setBottomNavigationVisible(false);

    if (props.token && redirectTo) {
      navigate(redirectTo);
    }

    setReturnTo(redirectTo);
  }, [
    props.context
  ]);

  useEffect(() => {
    changeEmail = ev => props.onChangeEmail(sanitizeInput(ev.target.value));
    changePassword = ev => props.onChangePassword(sanitizeInput(ev.target.value));
    submitForm = (email, password) => ev => {
      ev.preventDefault();
      props.onSubmit(email, password, redirectTo);
    };
    props.onUnload();
  }, []);

  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #0d1b2a 0%, #0d3d2e 100%)',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
      }}
    >
      <Typography
        variant="h1"
        sx={{ background: 'linear-gradient(90deg, #36c9a2 0%, #4facfe 35%, rgba(255,255,255,0.9) 50%, #4facfe 65%, #36c9a2 100%)', backgroundSize: '200% auto', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', fontWeight: 800, fontSize: { xs: '3rem', md: '4.5rem' }, letterSpacing: '-0.02em', mb: 4, textAlign: 'center', animation: `${titleShine} 4s linear infinite` }}
      >
        Freakland
      </Typography>
      <Box
        sx={{
          width: '100%',
          maxWidth: 420,
          backgroundColor: 'rgba(255,255,255,0.05)',
          backdropFilter: 'blur(12px)',
          border: '1px solid rgba(255,255,255,0.12)',
          borderRadius: 3,
          p: 4,
        }}
      >
        <Typography variant="h4" sx={{ color: 'white', fontWeight: 700, mb: 1, textAlign: 'center' }}>
          {translation.login.signIn}
        </Typography>
        <Typography variant="body2" sx={{ textAlign: 'center', mb: 4 }}>
          <Link to="/register" style={{ color: DEFAULT_THEME_COLOR, textDecoration: 'none' }}>
            {translation.login.needAccount}
          </Link>
        </Typography>
        <ListErrors errors={props.errors} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button
            fullWidth
            size="large"
            variant="contained"
            onClick={() => loginWithRedirect({ appState: { returnTo } })}
            sx={{ background: DEFAULT_GRADIENT, color: 'white', fontWeight: 700, py: 1.5, fontSize: '1rem', '&:hover': { background: DEFAULT_GRADIENT_HOVER } }}
          >
            {translation.login.buttons.signIn}
          </Button>
          <Button
            fullWidth
            size="large"
            variant="outlined"
            onClick={() => navigate('/places-restricted')}
            sx={{ borderColor: 'rgba(255,255,255,0.3)', color: 'rgba(255,255,255,0.7)', py: 1.5, fontSize: '1rem', '&:hover': { borderColor: DEFAULT_THEME_COLOR, color: DEFAULT_THEME_COLOR, backgroundColor: 'transparent' } }}
          >
            {translation.login.tryUsFirst}
          </Button>
        </Box>

        <AddToHomeScreenButton
          variant="outlined"
          size="medium"
          label={translation.login.addToHomeScreen}
          sx={{ mt: 2, width: '100%', py: 1.25, fontSize: '0.9rem' }}
        />
      </Box>
    </Box>
  );
};

const mapStateToProps = state => ({
  ...state.auth,
  token: state.common.token,
});

const mapDispatchToProps = dispatch => ({
  onChangeEmail: value =>
    dispatch({ type: UPDATE_FIELD_AUTH, key: 'email', value }),
  onChangePassword: value =>
    dispatch({ type: UPDATE_FIELD_AUTH, key: 'password', value }),
  onSubmit: (email, password, redirectTo) => {
    dispatch({ type: LOGIN, payload: agent.Auth.login(email, password), redirectTo })
  },
  onUnload: () =>
    dispatch({ type: LOGIN_PAGE_UNLOADED }),
  setBottomNavigationVisible: isVisible => dispatch({
    type: BOTTOM_NAVIGATION_VISIBILITY,
    payload: isVisible
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
